import { BaseEntity } from '../../../../../core/models/base-entity.model';
import { User } from '../../../../mgmt/user/models/user';
import { Author } from '../../../models/author';

export class PostComment extends BaseEntity<PostComment> {
  date?: Date;
  comment?: string;
  author?: Author;
  mentionedUsers?: Array<User>;
  public override deserialize(object: this): this {
    object.mentionedUsers = object.mentionedUsers
      ? object.mentionedUsers.map((item) => new User().deserialize(item))
      : [];
    return super.deserialize(object);
  }
}
